module.exports = __webpack_public_path__ + "static/img/Home58_active@2x.8e8a769.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Home58_active@2x.png
// module id = DH5w
// module chunks = 1